import { Component, Input, Output, EventEmitter } from '@angular/core';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'lib-search-input',
  templateUrl: './search-input.component.html',
  imports: [FormsModule, ReactiveFormsModule, NgbTypeaheadModule],
})
export class SearchInputComponent {
  @Input() id!: string;
  @Input() label!: string;
  @Input() placeholder!: string;
  @Input() model = '';
  @Output() searchChanged = new EventEmitter();

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => this.searchChanged.emit(term)),
    );
}
